export default reference => reference.type === "user";
